// editorAPI.js - API service for editor operations
import { fetchWithAuth } from "../apiutil";

export const editorAPI = {
  /**
   * Load user preferences for a clip
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @returns {Promise<Object>} Response with preferences data
   */
  loadPreferences: async (accessToken, caseId, clipId) => {
    console.log(
      `[editorAPI.loadPreferences] Loading preferences for clip ${clipId}`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/preferences`;
    return await fetchWithAuth(endpoint, { method: "GET" }, accessToken);
  },

  /**
   * Save user preferences for a clip
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @param {Object} preferences - Preferences object
   * @returns {Promise<Object>} Response indicating success/failure
   */
  savePreferences: async (accessToken, caseId, clipId, preferences) => {
    console.log(
      `[editorAPI.savePreferences] Saving preferences for clip ${clipId}`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/preferences`;
    return await fetchWithAuth(
      endpoint,
      {
        method: "POST",
        body: JSON.stringify(preferences),
      },
      accessToken
    );
  },

  /**
   * Load audio GUID for playback
   * @param {string} accessToken - Authentication token
   * @param {number} clipId - Clip ID
   * @param {number} channel - Channel number
   * @returns {Promise<Object>} Response with GUID data
   */
  loadAudioGUID: async (accessToken, clipId, channel) => {
    console.log(
      `[editorAPI.loadAudioGUID] Loading GUID for clip ${clipId}, channel ${channel}`
    );

    const endpoint = `/api/player/guid/${clipId}/${channel}`;
    return await fetchWithAuth(endpoint, { method: "GET" }, accessToken);
  },

  /**
   * Request filter operation on annotations
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @param {string} filterType - Type of filter ('EXTRACT', 'TRIM', etc.)
   * @param {Array} annotations - Annotations to process
   * @param {string} comment - Optional comment
   * @returns {Promise<Object>} Response indicating success/failure
   */
  requestFilter: async (
    accessToken,
    caseId,
    clipId,
    filterType,
    annotations,
    comment = ""
  ) => {
    console.log(
      `[editorAPI.requestFilter] Requesting ${filterType} filter for clip ${clipId} with ${annotations.length} annotations`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/filter`;
    const filterRequest = {
      clipId,
      filterType,
      annotations,
      comment,
    };

    return await fetchWithAuth(
      endpoint,
      {
        method: "POST",
        body: JSON.stringify(filterRequest),
      },
      accessToken
    );
  },
};
